import { SOCIAL_SECURITY_URLS } from './endpoints.constants';

const API_URL = process.env.API_URL;

const ENDPOINTS_SOCIAL_SECURITY = {
  get: {
    quoteBasisInitial: (employeeId) => `${API_URL}/${SOCIAL_SECURITY_URLS.ROOT}/${employeeId}/${SOCIAL_SECURITY_URLS.QUOTE_BASIS_INITIAL}`
  }
};

export {
  ENDPOINTS_SOCIAL_SECURITY
};



// WEBPACK FOOTER //
// ./client/app/common/endpoints/social-security.endpoints.js